import { Home } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconHome12Line = createIcon(Home, 12, "Line");
export const IconHome16Line = createIcon(Home, 16, "Line");
export const IconHome20Line = createIcon(Home, 20, "Line");
export const IconHome24Line = createIcon(Home, 24, "Line");
export const IconHome32Line = createIcon(Home, 32, "Line");
export const IconHome48Line = createIcon(Home, 48, "Line");
export const IconHome64Line = createIcon(Home, 64, "Line");
